import React, { useEffect } from 'react';
import classNames from 'classnames';
import { BreakLevel } from '@decisions/server/DecisionsFramework/BreakLevel';
import { ValidationRole } from './ValidationError';
import { Icon } from 'components/icons/Icon';
import { ValidationSummary } from 'utils/ValidationUtils';
// import './ValidationList.less'

interface IValidationListProps extends ValidationSummary {
  id?: string;
  className?: string;
  /**
   * Default behavior is 'tooltip'. Specify other to change rendering behavior.
   */
  role?: ValidationRole;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  hideErrorIcon?: boolean;
  validationTextClassName?: string;
  scheduleUpdate?: () => void;
  isOpen?: boolean;
  hasSolutions?: boolean;
  /** for closing if it's got solutions, etc. */
  onMouseLeave?: React.MouseEventHandler;
}

export const getClassName = (className?: string, role?: ValidationRole, hasSolutions?: boolean) =>
  classNames('dpc-validation-error', className, {
    'dpc-validation-error__list': role === 'list',
    'dpc-validation-error--with-solutions': hasSolutions,
  });

const getIconClassName = (level: BreakLevel) => {
  switch (level) {
    case BreakLevel.Fatal:
      return 'dpc-validation-error__icon-fatal';
    case BreakLevel.Warning:
      return 'dpc-validation-error__icon-warning';
    default:
      return 'dpc-validation-error__icon';
  }
};

const getValidationTextClassName = (className?: string) => classNames(`dpc-validation-error__reason`, className);
/**
 * Displays validation as a list
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export const ValidationList = React.forwardRef(
  (
    {
      id,
      className,
      role,
      reasons,
      levels,
      children,
      style,
      onMouseLeave,
      validationTextClassName,
      hideErrorIcon,
      scheduleUpdate,
      isOpen,
      hasSolutions,
    }: IValidationListProps,
    ref: React.Ref<HTMLUListElement>
  ) => {
    useEffect(() => {
      scheduleUpdate && scheduleUpdate();
    }, [scheduleUpdate, isOpen]);

    return (
      <ul
        ref={ref}
        id={id}
        className={getClassName(className, role, hasSolutions)}
        role={role}
        style={style}
        onMouseLeave={onMouseLeave}
      >
        {reasons.map((reason, i) => (
          <li key={reason} title={reason} className={getValidationTextClassName(validationTextClassName)}>
            {!hideErrorIcon ? <Icon className={getIconClassName(levels[i])} /> : null} {reason}
          </li>
        ))}
        {children}
      </ul>
    );
  }
);
